import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'
import workerSrc from 'pdfjs-dist/legacy/build/pdf.worker.entry'

const PdfViewer = {
  mounted() {
    const url = this.el.getAttribute('data-pdf-url')
    const scale = parseFloat(this.el.getAttribute('data-pdf-scale')) || 1.5

    pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc

    const container = this.el

    container.innerHTML = ''

    pdfjsLib.getDocument(url).promise.then((pdf) => {
      const renderPageSequentially = (pageNumber) => {
        if (pageNumber > pdf.numPages) {
          return
        }

        pdf.getPage(pageNumber).then((page) => {
          const viewport = page.getViewport({ scale })

          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')

          canvas.height = viewport.height
          canvas.width = viewport.width

          page.render({ canvasContext: context, viewport }).promise.then(() => {
            container.appendChild(canvas)
            renderPageSequentially(pageNumber + 1)
          })
        })
      }

      renderPageSequentially(1)
    })
  },
}

export default PdfViewer
